"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeReviewLink = exports.makeProductReviewsPageLink = exports.makeOrganizationVitrinsPageLink = exports.makeServiceReviewsPageLink = exports.makeOrganizationServiceReviewsPageLink = exports.makeOrganizationPageLink = void 0;
const helpers_1 = require("./helpers");
const types_1 = require("./types");
const makeOrganizationPageLink = (alias, type) => {
    const helper = (0, helpers_1.getOrganizationHelpers)(type);
    const typeForUrl = helper.typeForService === types_1.OrganizationTypes.Mfo ? 'zaimy/mfo' : helper.itemTypeUrl;
    return `/${typeForUrl}/${alias}/`;
};
exports.makeOrganizationPageLink = makeOrganizationPageLink;
const makeOrganizationServiceReviewsPageLink = (alias, type, serviceAlias) => {
    const helper = (0, helpers_1.getOrganizationHelpers)(type);
    const typeForUrl = helper.typeForService === types_1.OrganizationTypes.Mfo ? 'zaimy/mfo' : helper.itemTypeUrl;
    return `/${typeForUrl}/${alias}/${serviceAlias}/otzyvy/`;
};
exports.makeOrganizationServiceReviewsPageLink = makeOrganizationServiceReviewsPageLink;
const makeServiceReviewsPageLink = (serviceAlias) => {
    return `/${serviceAlias}/otzyvy/`;
};
exports.makeServiceReviewsPageLink = makeServiceReviewsPageLink;
const makeOrganizationVitrinsPageLink = (alias, type, serviceAlias) => {
    const helper = (0, helpers_1.getOrganizationHelpers)(type);
    return `/${serviceAlias}/${helper.itemTypeUrl}/${alias}/`;
};
exports.makeOrganizationVitrinsPageLink = makeOrganizationVitrinsPageLink;
const makeProductReviewsPageLink = ({ organizationType, productId, organizationAlias, serviceAlias, }) => {
    const helper = (0, helpers_1.getOrganizationHelpers)(organizationType);
    return `/${helper.itemTypeUrl}/${organizationAlias}/${serviceAlias}/otzyvy/${productId}/`;
};
exports.makeProductReviewsPageLink = makeProductReviewsPageLink;
const makeReviewLink = ({ productId, organizationType, organizationAlias, serviceAlias, }) => {
    const helper = (0, helpers_1.getOrganizationHelpers)(organizationType);
    const typeForUrl = helper.typeForService === types_1.OrganizationTypes.Mfo ? 'zaimy/mfo' : helper.itemTypeUrl;
    if (productId && serviceAlias) {
        return `/${typeForUrl}/${organizationAlias}/${serviceAlias}/otzyvy/${productId}/`;
    }
    if (serviceAlias) {
        return `/${typeForUrl}/${organizationAlias}/${serviceAlias}/otzyvy/`;
    }
    return `/${typeForUrl}/${organizationAlias}/otzyvy/`;
};
exports.makeReviewLink = makeReviewLink;
